import { withStylePrefix } from '../../common/withStylePrefix';
import { InteractiveSubItemComponent, interactiveSubItemTemplate } from './InteractiveSubItem';
import styles from './InteractiveSubItem.styles.scss';
export const interactiveSubItemDefinition = {
    baseName: 'interactive-sub-item',
    template: interactiveSubItemTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonInteractiveSubItem = InteractiveSubItemComponent.compose(interactiveSubItemDefinition);
